import React from 'react';

const Header = () => {
    return (
        <header className=''>
            <div className='nav container'>
                <h2>Country</h2>
                <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#">Shop</a></li>
                    <li><a href="#">About Us</a></li>
                </ul>
            </div>
        </header>
    );
};

export default Header;